<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'UserLayout',
})
</script>
<template>
  <div id="userLayout" :class="['user-layout-wrapper', isMobile && 'mobile']">
    <div class="container">
      <div class="user-layout-lang">
        <select-lang class="select-lang-trigger" />
      </div>
      <div class="user-layout-content">
        <div class="top">
          <div class="header">
              <img src="~@/assets/icons/logo.svg" class="logo" alt="logo" />
              <span class="title">{{ config.title }}</span>
          </div>
          <div class="desc">{{config.subtitle }}</div>
        </div>
        <router-view />
        <div class="footer">
          <div class="copyright">Copyright &copy;&nbsp;{{ config.copyright }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup name="UserLayout">
import SelectLang from '@/components/SelectLang';
import { isMobile } from '@/utils/device';
import { onMounted, onBeforeUnmount } from 'vue';
import config from '@/config/defaultSettings'

onMounted(() => {
  document.body.classList.add('userLayout');
});
onBeforeUnmount(() => {
  document.body.classList.remove('userLayout');
});
</script>

<style lang="less" scoped>
#userLayout.user-layout-wrapper {
  height: 100%;

  &.mobile {
    .container {
      .main {
        max-width: 368px;
        width: 98% !important;animation: pop-in .5s linear;
      }
    }
  }

  .container {

    width: 100%;
    min-height: 100%;
    background: radial-gradient(circle, #fafafa, #cfcfcf);
    background-size: cover;
    background-image: url(@/assets/img/bg3d.jpg);
    backdrop-filter:opacity(20%);
    //padding: 50px 0 84px;@/assets/background.svg
    position: relative;
    .main{
      animation: pop-in .5s linear;
      outline:10px solid rgba(255,255,255,.25);outline-offset: 0px;
      backdrop-filter: blur(5px);
    }
    .user-layout-lang {
      width: 100%;
      height: 40px;
      line-height: 44px;
      text-align: right;

      ::v-deep(.select-lang-trigger) {
        cursor: pointer;
        padding: 12px;
        margin-right: 16px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        vertical-align: middle;
      }
    }

    .user-layout-content {
      padding: 32px 0 24px;

      .top {
        text-align: center;

        .header {
          height: 44px;
          line-height: 44px;
          color:#fafafa;
          .badge {
            position: absolute;
            display: inline-block;
            line-height: 1;
            vertical-align: middle;
            margin-left: -12px;
            margin-top: -10px;
            opacity: 0.8;
          }

          .logo {
            height: 44px;
            vertical-align: top;
            margin-right: 16px;
            border-style: none;
          }

          .title {
            font-size: 33px;
            color:transparent;
            font-family: Avenir, 'Helvetica Neue', Arial, Helvetica, sans-serif;
            font-weight: 600;
            position: relative;
            top: 2px;
            display: inline-block;
            animation: ani-title 8s linear infinite;
            background:linear-gradient(60deg,#343434 0%,#fff 20%,#343434 40%);-webkit-background:linear-gradient(60deg,#343434 0%,#fff  20%,#343434 40%);
            background-clip: text;
            -webkit-background-clip: text;
            text-shadow: 2px 2px 4px rgba(0,0,0,.2);
          }

        }

        .desc {
          font-size: 14px;
          color: rgba(196, 196, 196, 0.75);
          margin-top: 12px;
          margin-bottom: 40px;
        }
      }

      .main {
        min-width: 260px;
        width: 368px;
        margin: 0 auto;
      }

      .footer {
        // position: absolute;
        width: 100%;
        bottom: 0;
        padding: 0 16px;
        margin: 48px 0 24px;
        text-align: center;

        .links {
          margin-bottom: 8px;
          font-size: 14px;

          a {
            color: rgba(196, 196, 196, 0.75);
            transition: all 0.3s;

            &:not(:last-child) {
              margin-right: 40px;
            }
          }
        }

        .copyright {
          color: rgba(196, 196, 196, 0.75);
          font-size: 14px;
        }
      }
    }

    a {
      text-decoration: none;
    }
  }
}
@keyframes ani-title{
  0%{background-position:1px center;}
  100%{background-position: 1000px  center;}
}
@keyframes pop-in{
  0%{transform: scale(0) rotateY(0deg);opacity: 0;}
  100%{transform: scale(1) rotateY(360deg);opacity: 1;}
}
</style>
